import OpenDesignVariantEnum from '../enums/OpenDesignVariantEnum.js';
export default class OpenDesignToastMessage {
    static getOpenDesignSuccess(localizedInformationOrTranslations, variant = OpenDesignVariantEnum.openDesign) {
        const { openDesignOpenDesignSuccess, importDesignSuccess } = this.getOpenDesignTranslations(localizedInformationOrTranslations);
        const label = variant === OpenDesignVariantEnum.openDesign
            ? openDesignOpenDesignSuccess
            : importDesignSuccess;
        return { label };
    }
    static getOpenDesignFailure(localizedInformationOrTranslations, variant = OpenDesignVariantEnum.openDesign) {
        const { openDesignOpenDesignFailure, importDesignFailure } = this.getOpenDesignTranslations(localizedInformationOrTranslations);
        const label = variant === OpenDesignVariantEnum.openDesign
            ? openDesignOpenDesignFailure
            : importDesignFailure;
        return { label };
    }
    static getOpenDesignTranslations(localizedInformationOrTranslations) {
        return 'translations' in localizedInformationOrTranslations
            ? localizedInformationOrTranslations.translations
            : localizedInformationOrTranslations;
    }
}
//# sourceMappingURL=OpenDesignToastMessage.js.map